/**
 * Phones must never zoom the game: a pinch, or a quick double tap on the gas
 * pedal, used to blow the page up. Android honours the viewport meta tag and
 * `touch-action`; iOS Safari ignores `user-scalable=no`, so its own gesture
 * events and a second tap in quick succession are cancelled here.
 */
export function disableZoom(): void {
  const block = (e: Event): void => {
    if (e.cancelable) e.preventDefault();
  };
  // Safari's pinch gestures.
  for (const type of ['gesturestart', 'gesturechange', 'gestureend']) document.addEventListener(type, block, { passive: false });
  // Any two-finger move is a pinch: nothing in the game scrolls with two fingers.
  document.addEventListener(
    'touchmove',
    (e) => {
      if (e.touches.length > 1) block(e);
    },
    { passive: false },
  );
  // A second tap within 350 ms on the open game view would zoom: cancel it. Buttons, fields and the
  // touch controls are left alone (they can't zoom, and cancelling would swallow a quick real tap).
  let lastEnd = 0;
  document.addEventListener(
    'touchend',
    (e) => {
      const now = performance.now();
      const control = (e.target as HTMLElement | null)?.closest?.('button, input, textarea, .interactive');
      if (now - lastEnd < 350 && !control) block(e);
      lastEnd = now;
    },
    { passive: false },
  );
  // Ctrl/Cmd + wheel (trackpad pinch on desktop browsers) zooms too.
  window.addEventListener(
    'wheel',
    (e) => {
      if (e.ctrlKey) block(e);
    },
    { passive: false },
  );
}
